import { Input, Component, ViewContainerRef, OnInit, ViewChild, AfterViewInit, TemplateRef, Output, EventEmitter, EmbeddedViewRef } from "@angular/core";

import { DialogService } from "../../../common/services/dialog.service";

import { deepClone } from "../../models/editor.model";

@Component({
    templateUrl: "./workflow-context-leaf.component.html",
    selector: "workflow-context-leaf",
    standalone: false
})

export class WorkflowContextLeafComponent implements OnInit, AfterViewInit {
  @Input() public context: any;
  @Input() public index: number;
  @Input() public key: string;

  @Output() public contextCopied = new EventEmitter<string>();
  @Output() public refreshView = new EventEmitter<boolean>();

  public editMode: boolean = false;
  public originalKey: string;
  public subkeys: any;
  public values: any;
  public deleteKey: string;

  constructor(
    public readonly dialogService: DialogService
  ) { }


  ngOnInit() {
    this.values = Object.values(this.context)[this.index];
    this.subkeys = Object.keys(this.values);
    this.originalKey = deepClone(this.key);
  }

  ngAfterViewInit() {

  }

  public addNewNode(): void {
    const descriptor = Object.getOwnPropertyDescriptor(this.context, this.key);
    descriptor.value = "";
    Object.defineProperty(this.context[this.key], "newProperty", descriptor);
    this.refreshView.emit(true);
  }

  public bubbleCopy(context: string): void {
    context = `${this.key}.${context}`;
    this.contextCopied.emit(context);
  }

  public bubbleRefresh(refresh: boolean): void {
    this.refreshView.emit(refresh);
  }

  public copyContextValue(value: string): void {
    this.contextCopied.emit(value);
  }

  public delete(deleteKey: string, prompt: boolean): void {
    if (prompt) {
      this.deleteKey = deleteKey;
      this.dialogService.openDialog("yesNo", "Only context nodes that were added via this page can be permanently deleted this way.  Context targets set on components must be changed on the components to be permanently removed from this view.  Do you wish to continue?");
    } else {
      delete this.context[deleteKey];
      this.refreshView.emit(true);
    }
  }

  public edit(): void {
    this.editMode = true;
  }

  public updateKey(): void {
    Object.defineProperty(this.context, this.key, Object.getOwnPropertyDescriptor(this.context, this.originalKey));
    this.delete(this.originalKey, false);
    this.editMode = false;
  }

  public onDialogConfirm(): void {
    this.dialogService.closeDialog();
    delete this.context[this.deleteKey];
    this.refreshView.emit(true);
  }

  public onDialogClose(): void {
    this.dialogService.closeDialog();
    console.log("Delete cancelled.");
  }

}
